import * as angular from 'angular';
import {IController} from "angular";

export class CustomOrderPlanningLayoutComponent implements IController {

  public selectedTabIndex: number = 0;
  
  // Parameters passed from router
  from: number;
  to: number;
  processStatus: string[];
  flowStatuses: string[];
  hasProject: boolean;
  hasRoute: boolean;

  constructor() {
  }

  $onInit() {
    // Initialize with upload table tab selected
    this.selectedTabIndex = 0;
  }

  onTabChange(tabIndex: number): void {
    this.selectedTabIndex = tabIndex;
  }
}

// Component registration
angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningLayout', {
    controller: CustomOrderPlanningLayoutComponent,
    template: require('./custom-order-planning-layout.html').default,
    bindings: {
      from: '<',
      to: '<',
      processStatus: '<',
      flowStatuses: '<',
      hasProject: '<',
      hasRoute: '<'
    }
  });
